import AppService, {LocalStorageService, Utilities, AlertService, track } from 's2s-app-service';
import crypto from 'crypto-browserify';
import themes from '../themes/theme-styles.js';
import { addLocaleData } from 'react-intl';
import Messages from '../js/messages';
import LoggingService from 's2s-logging-service';
import { doGetUserContacts } from './index';

// let settingsTimeout = 0;

// TODO Need to save audio settings to store and send to VertoService
const doCallVoicemail = () =>{
  LoggingService.getInstance().info('AC ---- doCallVoicemail');
  return (dispatch, getState) =>{
    //step 1 figure out voicemail number
    const store = getState();
    let vmNumber = '';
    const vmNumberGuard = () =>{
      if (!(store.callInfo && store.callInfo.dialPlanOptions && store.callInfo.dialPlanOptions.customerfeaturecodes)){
        vmNumber = AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_DIALING_OPTIONS', 'Dialing Options'), alertBodyText: Utilities.getInstance().getIntlMessage('ALERT_DIALING_OPTIONS_BODY', 'missing dial plan options'), isPersistent: false});
        LoggingService.getInstance().debug('customer feature codes', !(store.callInfo.dialPlanOptions.customerfeaturecodes));

      } else {
        vmNumber = Utilities.getDialPlanOptions(store.callInfo.dialPlanOptions.customerfeaturecodes, "VM Extension");
      }
      return vmNumber;
    };
    LoggingService.getInstance().debug('VVVV', vmNumberGuard() );
    //step 2 dispatch nbr to call
    dispatch(doMakeCall(vmNumberGuard()));
    dispatch({
      type: 'APP_SHOW_DTMF',
      payload: true
    });
  };
};

const doSendToVoicemail = (callId) =>{
  LoggingService.getInstance().info('AC ---- doSendToVoicemail', callId);
  return (dispatch, getState) =>{
    //step 1 figure out voicemail number
    const store = getState();

    let vmPrefix = '';
    const vmPrefixGaurd = () =>{
      if (!(store.callInfo && store.callInfo.dialPlanOptions && store.callInfo.dialPlanOptions.customerfeaturecodes)){
        vmPrefix = AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_DIALING_OPTIONS', 'Dialing Options'), alertBodyText: Utilities.getInstance().getIntlMessage('ALERT_DIALING_OPTIONS_BODY', 'missing dial plan options'), isPersistent: false});
        LoggingService.getInstance().debug('customer feature codes', !(store.callInfo.dialPlanOptions.customerfeaturecodes));

      } else {
        vmPrefix = Utilities.getDialPlanOptions(store.callInfo.dialPlanOptions.customerfeaturecodes, "Voicemail Prefix");
      }
      return vmPrefix;
    };

    const myNumber = store.settings.selectedExtension;
    //step 2 transfer number
    AppService.getInstance().getCallService().transfer(callId, vmPrefixGaurd()+myNumber);

  };
};

const doApiBroadcast = (payload) =>{
  LoggingService.getInstance().info('AC ---- doApiBroadcast');
  return (dispatch, getState) =>{
    LoggingService.getInstance().debug('************ api_broadcast payload');
    const store = getState();
    // get current selectedExtension
    const selectedExtension = store.settings.selectedExtension;

    // handle voicemail unread_count here.  Other api_broadcast fall through
    if ((payload.data.elements.data.data.voicemail && payload.data.elements.data.data.voicemail.ext_number === selectedExtension) ||
        payload.data.elements.data.data.extension_number === selectedExtension ) {
        LoggingService.getInstance().debug('>>>>>>> voicemail', payload.data.elements.data.data.unread_count);
      dispatch ({
        type: "VOICEMAIL_COUNT",
        payload: payload.data.elements.data.data.unread_count
      });
    }
  };
};

const doToggleSettingsOpen = (value) => {
  LoggingService.getInstance().info('AC ---- doToggleSettingsOpen', value);
  return (dispatch, getState) =>{
    const store = getState();

    dispatch ({
      "type": 'TOGGLE_SETTINGS_OPEN',
      "payload": value,
      "meta": {
        "analytics":{
          'category':'isSettingsOpen',
          'action': 'toggle',
          'value': value
        }
      }
    });
  };
};

const doKeepSettingsOpen = (value) => {
  LoggingService.getInstance().info('AC ---- doKeepSettingsOpen', value);
  return (dispatch, getState) =>{
    const store = getState();

    dispatch ({
      "type": 'TOGGLE_KEEP_SETTINGS_OPEN',
      "payload": value,
      "meta": {
        "analytics":{
          'category':'shouldSettingsStayOpen',
          'action': 'toggle',
          'value': value
        }
      }
    });
  };
};

// const doAppRestartForSettingsUpdate = () => {
//   return (dispatch, getState) => {
//     const store = getState();
//
//     const callInfo = store.callInfo;
//
//     if (store.app.settingsUpdated === true) {
//       if (Utilities.allowRestart(callInfo)){
//           // only if we are connected, set restarting to true, since we can change settings without being logged in
//           if (store.app.status && store.app.status.status === 'connected') {
//             LocalStorageService.setData('restarting', true);
//           }
//
//           AppService.getInstance().restart();
//         } else {
//           if (!store.app.appRestartRequired){ // did it once already
//             // dispatch to update appRestartRequired so we will restart when able.
//             dispatch ({
//                         'type': 'APP_RESTART_REQUIRED',
//                         'payload': true
//                       });
//
//             AlertService.getInstance().createWarnAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_SETTINGS_WILL_APPLY', 'Active calls; settings will apply when idle.')});
//           }
//         }
//     }
//   };
// };

const doMedia = () =>{
  LoggingService.getInstance().info('AC ---- doMedia');
  return (dispatch, getState) =>{
    AppService.getInstance().refreshDevices((status, data)=>{
      LoggingService.getInstance().info('refresh returned with: ');
      if (status){
        LoggingService.getInstance().debug('sssss::::', status);
        delete data._activeCalls;
        delete data._maxActiveCalls;
        dispatch({
          "type": "MEDIA",
          "payload": data
        });

        setTimeout(()=>{
          var data = {};
          var store = getState();

          //building data to be sent to call 
          data.inputDevice = {  
            id: store.settings.selectedAudio.id,
            kind: 'audio_in',
            label: store.settings.selectedAudio.label
          };
          data.outputDevice = { 
            id: store.settings.selectedSpeaker.id,
            kind: 'audio_out', 
            label: store.settings.selectedSpeaker.label
          };
          // get call service so i only do it once 
          const callService = AppService.getInstance().getCallService();
          // loop through all calls and sent audio 
          Object.keys(store.callInfo.inprogressCalls).forEach((callId)=>{
            LoggingService.getInstance().debug('################ in/out devices to be set', data);

            // send to Verto to activate settings
            callService.setAudio(callId, data);
          })

        }, 0)
      }

    });
  };
};


const doConnected = (payload,history) =>{
  return((dispatch, getState) => {
    LoggingService.getInstance().info('AC ---- doConnected');

    //This is in place so that when device/ringtone is changed in settigns the settings menu will not close.
    if(location.href.indexOf('settings') === -1 ){
      history.push('/appmain/phone');
    }

    dispatch( {
      "type": "CONNECTED",
      "payload": payload
    });
    //console.log('--------------------doConnected!!!')
    // get user contactlist
    dispatch(doGetUserContacts());

  });
};

// verto login callback
const doVertoLogin = (success, data,history) => {
  LoggingService.getInstance().info('AC ---- doVertoLogin', success );
  return dispatch => {
    LoggingService.getInstance().debug('verto Login ....', data);
    if(success){
      dispatch(doVertoLoginValid(data));
      //dispatch(doSpeedTest());
    } else {
      history.push('/appmain/login');

      dispatch({
        type: "LOGIN_FAILED",
        "meta": {
          "analytics":{
            'category':'login',
            'action': 'loginFailure'
          }
        }
      });
    }
  };
};

const doVertoLoginValid = (data) => {
  LoggingService.getInstance().info('AC ---- doVertoLoginValid');
  return {
    "type": "VERTO_LOGIN",
    "payload": data,
    "meta": {
      "analytics":{
        'category':'login',
        'action': 'loginSuccess'
      }
    }
  };
};

// making a phone call
const doIncomingCall = (dialog) =>{
  LoggingService.getInstance().info('AC ---- doIncomingCall');
  return (dispatch) => {
    dispatch({
      type: "INCOMING_CALL",
      payload: dialog,
        "meta": {
          "analytics":{
            'category':'softphone',
            'action': 'incomingCall'
          }
        }
    });
  };
};

const doMakeCall = (aPhoneNumber) => {
  LoggingService.getInstance().info('AC ---- doMakeCall', aPhoneNumber);
  return (dispatch, getState) => {
    LoggingService.getInstance().debug('>>>> appSetttings: ', aPhoneNumber, getState().settings);

    const phNum = Utilities.cleanPhoneNumber(aPhoneNumber);

    LoggingService.getInstance().debug('doMakeCall   phone nubmer', aPhoneNumber, phNum);

    const callID = AppService.getInstance().getCallService().makeCall(phNum, getState().settings);
    //console.log('>>>> CALLID: ',  callID);
    // if (callID){
    //   dispatch(doingMakeCall('trying', phNum, callID, 'outbound'));
    // }
  };
};

const doShareScreen = (appSettings) => {
  LoggingService.getInstance().info('AC ---- doShareScreen', appSettings);
  return dispatch => {
    AppService.getInstance().getCallService().shareScreen(appSettings);
    dispatch({
      "type": "ATTEMPTING_SHARING_SCREEN"
    });
  };
};

const doHangUp = (callId) => {
  LoggingService.getInstance().info('AC ---- doHangUp', callId);

  return (dispatch, getState) =>{
    LoggingService.getInstance().debug('hangup action creator ', callId);
    AppService.getInstance().getCallService().hangup(callId);
    dispatch({
      type: 'APP_SHOW_DTMF',
      payload: false
    });
  };
};

const doRejectCall = (callId) => {
  LoggingService.getInstance().info('AC ---- doRejectCall',callId);
  return (dispatch) =>{
    AppService.getInstance().getCallService().reject(callId);
  };
};

const doHold = (callId) => {
  LoggingService.getInstance().info('AC ---- doHold', callId);
  return (dispatch) =>{
    AppService.getInstance().getCallService().hold(callId);
  };
};

const doMuteMic = (callId) => {
  LoggingService.getInstance().info('AC ---- doMuteMic', callId);
  return (dispatch) =>{
    AppService.getInstance().getCallService().muteMic(callId);
  };
};

const doSetActiveCall = (clickedCallObject) =>{
  LoggingService.getInstance().info('AC ---- doSetActiveCall');
  return (dispatch,getState) =>{
    const store = getState();
    LoggingService.getInstance().debug('>>>>>>>>>>>>>>', clickedCallObject.callId, store.callInfo.activeCallId, clickedCallObject.callId != store.callInfo.activeCallId);
    if (clickedCallObject.callId != store.callInfo.activeCallId){
      LoggingService.getInstance().debug('>>>>>', store.callInfo.inprogressCalls[store.callInfo.activeCallId] && !store.callInfo.inprogressCalls[store.callInfo.activeCallId].held);
      if (store.callInfo.inprogressCalls[store.callInfo.activeCallId] && !store.callInfo.inprogressCalls[store.callInfo.activeCallId].held){
        dispatch (doHold(store.callInfo.activeCallId));
      }
      dispatch ({
        "type": "ACTIVE_CALL",
        "payload": clickedCallObject,
        "meta": {
          "analytics":{
            'category':'softphone',
            'action': 'activeCall'
          }
        }
      });

    }

  };

};

const doMuteVideo = (callId) => {
  LoggingService.getInstance().info('AC ---- doMuteVideo', callId);
  return (dispatch) =>{
    AppService.getInstance().getCallService().muteVideo(callId);
  };
};

const doSendConfCommand = (cmd, params) => {
  LoggingService.getInstance().info('AC ---- doSendConfCommand', cmd, params);
  return (dispatch) =>{
    AppService.getInstance().getCallService().sendConferenceCommand(cmd, params);
  };
};

const doConferenceData = (confData) =>{
  LoggingService.getInstance().info('AC ---- doConferenceData');
  return {
    "type": "CONFERENCE_DATA",
    "payload": confData,
    "meta": {
      "analytics":{
        'category':'softphone',
        'action': 'conferenceData'
      }
    }
  };
};

const doAnswer = (callId) => {
  LoggingService.getInstance().info('AC ---- doAnswer', callId);
  return (dispatch, getState) =>{
    const store = getState();

    if (store.callInfo.inprogressCalls[store.callInfo.activeCallId] && !store.callInfo.inprogressCalls[store.callInfo.activeCallId].held){
      dispatch (doHold(store.callInfo.activeCallId));
    }
    AppService.getInstance().getCallService().answer(callId);

  };
};

const doHungUp = (dialog,history) =>{
  //LoggingService.getInstance().info('AC ---- doHungUp');
  return (dispatch, getState) => {
    const store = getState();
    dispatch ({
      "type": "CALL_HUNG_UP",
      "payload": dialog,
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'hungup'
        }
      }
    });

    // SOFTPHONE 178 - if starphone user opens dtmf and user on other end hangs up the phone we will close dtmf pad to prevent from appearing in future calls. - KCN
    if(store.app.showDTMFKeypad === true){
      dispatch ({
        "type": "APP_SHOW_DTMF",
        "payload": false,
      });
    }


    if (Object.keys(store.callInfo.inprogressCalls).length  == 1 && store.callInfo.inprogressCalls[dialog.callID]){

      //last call so fire call state
      LoggingService.getInstance().info('do hung up --- last call ');
      dispatch ({
        "type": "CALL_STATE",
        "payload": 'last-call'
      });
      if (store.app.isSettingsPendingUpdate){
        setTimeout(()=>{
          dispatch(doUpdateCallServiceSettings());
        }, 100); // jes set to the end of call stack so we give verto time to end
      }
      //jes Softphone-89 issue so pushing it to the end of the call stack fixed this issue ... dont remove it
      setTimeout(()=>{history.push('/appmain/phone'); }, 100);
    } else if (!store.callInfo || !store.callInfo.inprogressCalls || Object.keys(store.callInfo.inprogressCalls).length  == 0){
      LoggingService.getInstance().info('do hung up --- no calls  ');
      dispatch ({
        "type": "CALL_STATE",
        "payload": 'no-calls'
      });
      if (store.app.isSettingsPendingUpdate){
        setTimeout(()=>{
          dispatch(doUpdateCallServiceSettings());
        }, 100); // jes set to the end of call stack so we give verto time to end
      }
      //jes Softphone-89 issue so pushing it to the end of the call stack fixed this issue ... dont remove it
      setTimeout(()=>{history.push('/appmain/phone'); }, 100);
    } else {
      LoggingService.getInstance().info('do hung up --- in progress calls ');
      dispatch ({
        "type": "CALL_STATE",
        "payload": 'inprogress-call'
      });
      history.push('/appmain/callInProgress');
    }

    // If one of our transfer numbers hungup...  call CLEANUP_ATTENDED_TRANSFER to clean
    // the transfer data from the store.
    // If activeCall hungup, only do the cleanup if the transfer data is in store (store.callInfo.transferCallId exists)
    if (store.callInfo.transferCallId === dialog.callID || (store.callInfo.transferCallId && store.callInfo.activeCallId === dialog.callID)) {
      LoggingService.getInstance().info('do hung up --- cleanup attended transfer ');
      dispatch({
        "type": "CLEANUP_ATTENDED_TRANSFER",
        "payload": store.callInfo.inprogressCalls
      });
      Object.keys(store.callInfo.inprogressCalls).length > 0 ? history.push('/appmain/callInProgress') : history.push('/appmain/phone');
    }
  };
};

const doMakeCallError = (aErrorObject, history) =>{
  LoggingService.getInstance().info('AC ---- doMakeCallError');
  return (dispatch, getState) => {

    const store = getState();
    const hasInprogressCalls = Object.keys(store.callInfo.inprogressCalls).length > 0;
    const payload = { ... aErrorObject, hasInprogressCalls };

    if (payload.hasInprogressCalls) {
        history.push('/appmain/callInProgress');
    } else {
        history.push('/appmain/phone');
    }

    dispatch( {
      "type": "CALLING_ERROR",
      payload,
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'callError'
        }
      }
    });
  };
};

const doingMakeCall = (status, destination, callId, direction, timestamp, dialog, history ) => {
  LoggingService.getInstance().info('AC ---- doingMakeCall');

  return (dispatch, getState) => {
    const store = getState();

    // call doSaveAudioSettings to send the saved audioSettings to the call record for this call
    // We are doing this here because the phone will fall back to the computer's default setting
    // for the call rather than the setting for the softphone.
    // setTimeout to allow connection to settle...
    //console.log('Setting audioSettings in doSetActiveCall');
    //console.log('.........setAudio', { ...store.callInfo.inprogressCalls[callId]})
    //setTimeout(()=>{
      dispatch(doSaveAudioSettings());
    //},1000);

    dispatch ({
      "type": "CALLING",
      "payload": {status, destination, callId, direction, timestamp, dialog },
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'calling'
        }
      }
    });

    if(getState().callInfo.transferCallId) {
        history.push('/appmain/attendedTransfer');
    } else if (status === 'trying') {
        history.push('/appmain/dialing');
    } else {
        history.push('/appmain/callInProgress');
    }

  };
};

const doCallHeld = (callID) =>{
  LoggingService.getInstance().info('AC ---- doCallHeld', callID);
  return {
    "type": "CALL_HELD",
    "payload": callID,
    "meta": {
      "analytics":{
        'category':'softphone',
        'action': 'callHeld'
      }
    }
  };
};

const doSendChat = (message) => {
  LoggingService.getInstance().info('AC ---- doSendChat', message);
  return (dispatch) => {
    AppService.getInstance().getCallService().sendConferenceChat(message);
    dispatch(doingSendingChat());
  };
};

const doReceiveChat = (messageObject) => {
  LoggingService.getInstance().info('AC ---- doReceiveChat', messageObject);
  return (dispatch) =>{
    dispatch({
      type: 'RECEIVED_CHAT_MESSAGE',
      payload: messageObject,
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'chatReceived'
        }
      }
    });
  };
};

const doingSendingChat = () => {
  LoggingService.getInstance().info('AC ---- doingSendingChat');
  return {
    type: 'SENDING_CHAT_MESSAGE',
    "meta": {
      "analytics":{
        'category':'softphone',
        'action': 'sendChat'
      }
    }
  };
};

const doClearHistory = () => {
  LoggingService.getInstance().info('AC ---- doClearHistory');
  return (dispatch) =>{
    dispatch({
      type: 'CLEARING_HISTORY',
      "meta": {
        "analytics":{
          'category':'callHistory',
          'action': 'cleared'
        }
      }
    });
  };
};

const doShowAlert = (aData) => {
  LoggingService.getInstance().info('AC ---- doShowAlert', aData);
  return {
    "type": "NEW_ALERT",
    "payload": aData,
    "meta": {
      "analytics":{
        'category':'alerts',
        'action': 'show'
      }
    }
  };
};

const doDeleteAlert = (alertId) => {
  LoggingService.getInstance().info('AC ---- doDeleteAlert', alertId);
  return (dispatch) =>{
    AlertService.getInstance().deleteAlert(alertId);
    dispatch({
      "type": "DELETE_ALERT",
      "payload": alertId,
      "meta": {
        "analytics":{
          'category':'alerts',
          'action': 'delete'
        }
      }
    });
  };

};

const doDismissAlert = (alertId) => {
  LoggingService.getInstance().info('AC ---- doDismissAlert', alertId);

  return (dispatch, getState) =>{
    const store = getState();
    const remainingAlerts = store.alerts.active.filter((alertData)=>{
      return alertData.alertId !== alertId;//payload will be alertId
    });

    dispatch({
      "type": "DISMISS_ALERT",
      "payload": remainingAlerts,
      "meta": {
        "analytics":{
          'category':'alerts',
          'action': 'dismiss'
        }
      }
    });
  };

};

const doDismissPersistent = () => {
  LoggingService.getInstance().info('AC ---- doDismissPersistent');
  return {
    "type": "DISMISS_PERSISTENT",
    "meta": {
      "analytics":{
        'category':'alerts',
        'action': 'dismissPersistent'
      }
    }
  };
};

const doClearAlerts = () => {
  LoggingService.getInstance().info('AC ---- doClearAlerts');
  return dispatch =>{
    dispatch({
      "type": "CLEARING_ALERT_HISTORY",
      "meta": {
        "analytics":{
          'category':'alertLog',
          'action': 'cleared'
        }
      }
    });
  };
};

const doInitiateTransfer = (history) => {
  LoggingService.getInstance().info('AC ---- doInitiateTransfer');
  return (dispatch, getState) =>{

    // is current call on hold
    const store = getState();
    const callId = store.callInfo.activeCallId;
    if (store.callInfo.inprogressCalls[callId] && !store.callInfo.inprogressCalls[callId].held){
      // hold call
      AppService.getInstance().getCallService().hold(callId);
    }


    dispatch({
      "type": "INITIATE_TRANSFER",
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'initiateTransfer'
        }
      }
    });
    history.push('/appmain/initiateTransfer');
  };
};

const doAttendedTransfer = (data, history) => {
  LoggingService.getInstance().info('AC ---- doAttendedTransfer',data);
  return (dispatch, getState) => {
    const store = getState();

    dispatch({
      "type": "ATTENDED_TRANSFER",
      "payload": { transferCallId: store.callInfo.activeCallId,
                transferToNbr: data.transferToNbr},
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'attendedTransfer'
        }
      }
    });
    dispatch(doMakeCall(data.transferToNbr));
    history.push('/appmain/attendedTransfer');
  };
};

const doCompleteAttendedTransfer = (history) => {
  LoggingService.getInstance().info('AC ---- doCompleteAttendedTransfer');
  return (dispatch, getState) => {
    const store = getState();

    AppService.getInstance().getCallService().attendedTransfer(store.callInfo.transferCallId, store.callInfo.activeCallId);

    dispatch({
       "type": "CLEANUP_ATTENDED_TRANSFER",
       "payload": store.callInfo.inprogressCalls,
       "meta": {
         "analytics":{
           'category':'softphone',
           'action': 'completeAttendedTransfer'
         }
       }
    });
    Object.keys(store.callInfo.inprogressCalls).length > 0 ? history.push('/appmain/callInProgress') : history.push('/appmain/phone');
  };
};

const doCompleteTransfer = (data) => {
  LoggingService.getInstance().info('AC ---- doCompleteTransfer', data);
  return (dispatch, getState) => {
    const store = getState();

    AppService.getInstance().getCallService().transfer(data.callId, data.transferToNbr);

    if (Object.keys(store.callInfo.inprogressCalls).length  > 2 ){
      // if there are two calls, then we want to go to the call_inprogress page not the loggedin page

      dispatch ({
        "type": "CALL_STATE",
        "payload": 'transferring',
        "meta": {
          "analytics":{
            'category':'softphone',
            'action': 'completeTransfer'
          }
        }
      });
    }
  };
};

const doCancelTransfer = (history) => {
  LoggingService.getInstance().info('AC ---- doCancelTransfer');
  return (dispatch, getState) => {
    dispatch({
      "type": "CANCEL_TRANSFER",
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'cancelTransfer'
        }
      }
    });
    history.push('/appmain/callInProgress');
  };
};

const doDTMFDial = (value) => {
  LoggingService.getInstance().info('AC ---- doDTMFDial', value);
  return (dispatch, getState) =>{
    const store = getState();
    const callId = store.callInfo.activeCallId;

    AppService.getInstance().getCallService().sendDtmf(callId, value);
    dispatch({
      "type":"DTMF_DIALED",
      "meta": {
        "analytics":{
          'category':'softphone',
          'action': 'dtmfDialed'
        }
      }
    });
  };
};

const doCloseDTMFKeypad = ()=>{
  LoggingService.getInstance().info('AC ---- doCloseDTMFKeypad');
  return {
    type: 'APP_SHOW_DTMF',
    payload: false,
    "meta": {
      "analytics":{
        'category':'callcontrols',
        'action': 'keypad'
      }
    }
  };
};

const doShowDTMFKeypad = ()=>{
  LoggingService.getInstance().info('AC ---- doShowDTMFKeypad');
  return {
    type: 'APP_SHOW_DTMF',
    payload: true,
    "meta": {
      "analytics":{
        'category':'callcontrols',
        'action': 'keypad'
      }
    }
  };
};

const doCloseAddCallKeypad = ()=>{
  LoggingService.getInstance().info('AC ---- doCloseAddCallKeypad');
  return {
    type: 'APP_SHOW_ADD_CALL_KEYPAD',
    payload: false,
    "meta": {
      "analytics":{
        'category':'callcontrols',
        'action': 'newCall'
      }
    }
  };
};

const doShowAddCallKeypad = ()=>{
  LoggingService.getInstance().info('AC ---- doShowAddCallKeypad');
  return {
    type: 'APP_SHOW_ADD_CALL_KEYPAD',
    payload: true,
    "meta": {
      "analytics":{
        'category':'callcontrols',
        'action': 'newCall'
      }
    }
  };
};

const doSaveAudioSettings = (data) => {
  LoggingService.getInstance().info('AC ---- doSaveAudioSettings', data);
  // data is the object
  //       inputVolume:
  //       inputDevice:
  //       outputVolume:
  //       outputDevice:

  return (dispatch, getState) => {
    const store = getState();

    // if data is not passed in, use the current settings and set volume to 1.
    // this is to handle resetting the audio for the call in progress when answered.
    if (data == undefined) {
      data = {};
      data.inputDevice = {  id: "",
                            kind: 'audio_in',
                            label: undefined};
      data.outputDevice = { id: store.settings.selectedSpeaker.id,
                            kind: 'audio_out', label: store.settings.selectedSpeaker.label};
      data.outputVolume = 1;

      // do i have an active call
      if (store.callInfo.hasOwnProperty('activeCallId') && store.callInfo.inprogressCalls.hasOwnProperty(store.callInfo.activeCallId)){
        // ok have an active call
        if (store.callInfo.inprogressCalls[store.callInfo.activeCallId].hasOwnProperty('audioSettings')){
          // ok got active call with already set audio settings so i am just going to use it
          LoggingService.getInstance().debug('^^^^ using already set audio settings for active call', store.callInfo.inprogressCalls[store.callInfo.activeCallId]['audioSettings']);
          data = { ...store.callInfo.inprogressCalls[store.callInfo.activeCallId]['audioSettings']};
        }
      }
    } else {
      // Use the data passed in for audio settings
      // this was due to end user changing settings

      // look up the corresponding id for selected input and output devices from
      // the settings store
      const inputDeviceId = store.settings.audioDevices.reduce((p,c)=>{
        if (p && p.length > 0 ) return p;
        if (c.label === data.inputDevice) return c.id;
        return p;
      }, "");

      const outputDeviceId = store.settings.speakerDevices.reduce((p,c)=>{
        if (p && p.length > 0 ) return p;
        if (c.label === data.outputDevice) return c.id;
        return p;
      }, "");

      // Augment data so that input and output devices are objects that are
      // expected by Verto
      data.inputDevice = {  id: inputDeviceId,
                            kind: 'audio_in',
                            label: data.inputDevice};
      data.outputDevice = { id: outputDeviceId,
                            kind: 'audio_out', label: data.outputDevice};
    }

    LoggingService.getInstance().debug('################ in/out devices to be set', data);

    // send to Verto to activate settings
    AppService.getInstance().getCallService().setAudio(store.callInfo.activeCallId, data);

    // save to store
    dispatch({
      "type": 'SAVE_AUDIO_SETTINGS',
      "payload": data,
      "meta": {
        "analytics":{
          'category':'audioSettings',
          'action': 'updated',
          "meta": {
            "analytics":{
              'category':'audioSettings',
              'action': 'saveAudioSettings'
            }
          }
        }
      }
    });
  };
};

const doUpdateCallServiceSettings= () =>{
  LoggingService.getInstance().info('AC ---- doUpdateCallServiceSettings');
  return (dispatch, getState) =>{
    const store = getState();
    LoggingService.getInstance().debug('--------------- update call service settings --------------------------');
    // this does the actual saving
    AppService.getInstance().updateSettings(store.settings);
    // nobody is listening for this but future if needed
    dispatch ({
      "type": 'UPDATE_CALL_SERVICE_SETTINGS',
      "payload": store.settings
    });
    dispatch({
      "type": "PROCESS_DEFERRED_SETTINGS_UPDATE",
      "payload": {}
    });
  };
};

export { doConnected, doVertoLogin, doUpdateCallServiceSettings,
  doMakeCall, doMakeCallError, doIncomingCall, doShareScreen, doToggleSettingsOpen, doKeepSettingsOpen, doMedia,
  doingMakeCall, doHungUp, doHangUp, doAnswer, doMuteMic, doConferenceData, doHold, doMuteVideo, doCallHeld,
  doSendChat, doReceiveChat, doingSendingChat,doSendConfCommand, doClearHistory, doShowAlert, doDismissAlert, doDeleteAlert,
  doDismissPersistent, doClearAlerts, doApiBroadcast, doSaveAudioSettings, doInitiateTransfer, doCompleteTransfer,
  doCallVoicemail, doCancelTransfer, doSendToVoicemail, doDTMFDial, doCloseDTMFKeypad, doShowDTMFKeypad, doCloseAddCallKeypad,
  doShowAddCallKeypad, doAttendedTransfer, doCompleteAttendedTransfer, doSetActiveCall, doRejectCall };



// WEBPACK FOOTER //
// ./src/action-creators/phone.js